import React, { FC, useEffect } from 'react'
import { Flex } from '@chakra-ui/react'
import { ArticleSummaryProps, useArticleSummary } from '../ArticleSummary/hook'
import { ContentPdfAIReport } from './ContentPdfAIReport'

/**
 * ArticleSummary component page.
 * @return {JSX.Element} ArticleSummary component.
 */
export const ArticleSummaryReport: FC<ArticleSummaryProps> = props => {
  const {
    company,
    selectedNewsId,
    baseNewsId,
    block,
    pdfPage,
    isFixHeight = '28vh',
    newsId,
    data: { data, loading, error },
    handleSetPagePdf,
    isDetailModalOpen,
  } = useArticleSummary(props)

  useEffect(() => {
    if (props.onLoadingChange && company?.news_id) {
      props.onLoadingChange(company.news_id, loading)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, company?.news_id])

  return (
    <Flex
      boxSizing="border-box"
      flexDirection="column"
      gap="12px"
      height={`${isDetailModalOpen ? '65vh' : isFixHeight}`}
      mb={3}
      overflow="auto"
      px={3}
      py={3}
      sx={{
        '&::-webkit-scrollbar': {
          width: '4px',
          height: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#A0AEC0',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          background: '#718096',
        },
        '&::-webkit-scrollbar-track': {
          background: '#EDF2F7',
          borderRadius: '4px',
        },
      }}
      width="100%"
    >
      <ContentPdfAIReport
        baseNewsId={baseNewsId}
        block={block}
        company={company}
        data={data}
        error={error}
        handleSetPagePdf={handleSetPagePdf}
        isDetailModalOpen={isDetailModalOpen}
        loading={loading}
        newsId={newsId}
        pdfPage={pdfPage}
        selectedNewsId={selectedNewsId}
      />
    </Flex>
  )
}
